export default function CompanyInfo() {
  const info = [
    { label: '会社名', value: '合同会社ふらっと', link: null },
    { label: '住所', value: '〒177-0051　東京都練馬区関町北4-31-19', link: null },
    { label: '連絡先', value: '03-6279-7967', link: 'tel:0362797967' },
    { label: '代表社員', value: '吉野　均', link: null },
    { label: '設立', value: '2022年12月1日', link: null },
  ];

  return (
    <section id="company" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="mb-16">
          <div className="text-xs text-gray-500 font-light mb-3 tracking-wider">COMPANY</div>
          <h2 className="text-5xl font-extrabold text-gray-900 leading-tight">
            <a href="#company" className="hover:text-[#14B8A6] transition-colors cursor-pointer">
              会社概要
            </a>
          </h2>
        </div>

        <div className="max-w-3xl">
          {info.map((item, index) => (
            <div
              key={index}
              className={`flex items-start py-6 ${index < info.length - 1 ? 'border-b border-gray-100' : ''}`}
            >
              <span className="w-32 shrink-0 text-sm text-gray-500 font-medium pt-0.5">
                {item.label}
              </span>
              {item.link ? (
                <a
                  href={item.link}
                  className="text-base text-[#14B8A6] hover:text-[#0F9B8E] transition-colors cursor-pointer"
                >
                  {item.value}
                </a>
              ) : (
                <span className="text-base text-gray-900">{item.value}</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
